import { render } from "./import-file.vue?vue&type=template&id=7e5649ab&ts=true"
import script from "./import-file.ts?vue&type=script&lang=ts&external"
export * from "./import-file.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__